export var SubscriptionType;
(function (SubscriptionType) {
  SubscriptionType[SubscriptionType["FREE"] = 1] = "FREE";
  SubscriptionType[SubscriptionType["PREMIUM"] = 2] = "PREMIUM";
  SubscriptionType[SubscriptionType["LITE"] = 4] = "LITE";
  SubscriptionType[SubscriptionType["AUCTION"] = 18] = "AUCTION";
})(SubscriptionType || (SubscriptionType = {}));